import { DateTime } from 'luxon';
import { CitizenshipFormVM } from 'mutation/view-models/registration-citizenship';
import { DatiAggiuntiviSide, ModelEventoDTO } from 'shell/models/act-category-list';
import { ActType } from 'shell/constants/act-type';
import { ItemVM } from 'shell/view-models/item';
import { MotArtCitizenship } from 'shell/models/mutation/mot-art-citizenship';

export const transformerNewChoiceItalian = (
  modelEventoDTO?: ModelEventoDTO,
  datiAggiuntiviSide?: DatiAggiuntiviSide,
  subEvento?: string,
  idMotivoVariazioneCittadinanza?: ItemVM<MotArtCitizenship>
): CitizenshipFormVM | undefined => {
  if (!modelEventoDTO) {
    return;
  }

  const idAnscSplit = modelEventoDTO.idAnsc?.split('-') || [];

  return {
    reasonCitizenship: subEvento,
    choiceItalian: {
      article: idMotivoVariazioneCittadinanza,
      actType: ActType.AttoDigitale,
      digital: {
        documentDate: modelEventoDTO.dataformazione
          ? DateTime.fromISO(modelEventoDTO.dataformazione)
          : null,
        istatCode: datiAggiuntiviSide?.idComuneRegistrazione || '',
        municipality: datiAggiuntiviSide?.idComuneRegistrazione
          ? {
              description: datiAggiuntiviSide.nomeComuneRegistrazione || '',
              id: datiAggiuntiviSide.idComuneRegistrazione || '',
              province: datiAggiuntiviSide.siglaProvinciaRegistrazione || '',
              provinceCode: datiAggiuntiviSide.idProvinciaRegistrazione,
            }
          : undefined,
        year: idAnscSplit[0] || '',
        nationalNumber: idAnscSplit[1] || '',
        numberMunicipality: idAnscSplit[2] || '',
        idAnsc: modelEventoDTO.idAnsc,
      },
    },
  };
};
